<template>
  <v-container>
    <v-row>
      <v-col cols="3">
        <v-autocomplete
          v-model="selectedBlockId"
          dense
          label="Search by block"
          :items="blockList"
          class="pt-5"
        ></v-autocomplete>
      </v-col>
    </v-row>

    <h3 class="my-2">Block Report</h3>

    <div v-if="!blockReportData.length" class="mb-4">Select a Block to view a detailed report</div>
    <v-data-table
      v-else
      :headers="blockReportHeaders"
      :items="blockReportData"
      :items-per-page="100"
      dense
      :loading="$apollo.loading"
      class="mt-2 elevation-2"
    />

    <h3 class="my-2">Menus</h3>
    <v-data-table
      :headers="nutritionHeaders"
      :items="nutritionBlocks"
      :items-per-page="15"
      dense
      :loading="$apollo.loading"
      class="mt-2 elevation-2"
    />
    <h3 class="mt-6 mb-2">Programs</h3>
    <v-data-table
      :headers="headers"
      :items="workoutBlocks"
      :items-per-page="15"
      :loading="$apollo.loading"
      dense
      class="mt-2 elevation-2"
    />
  </v-container>
</template>

<script>
import { WORKOUT_BLOCKS_NODE_QUERY, BLOCK_REPORT } from "@/constants/graphql/blocks/workoutblocks";
import { NUTRITION_BLOCKS_QUERY } from "@/graphql/queries/nutrition";
import { extractNodes } from "@/lib/array";
import { decodeId } from "@/lib/string";

export default {
  name: "ProgramReport",
  components: {},
  data() {
    return {
      selectedBlockId: null,
      blockList: [],
      blockReportData: [],
      nutritionHeaders: [
        { text: "Title", value: "title" },
        { text: "Active Users", value: "activeUsers" },
        { text: "Completed Users", value: "completedUsers" },
      ],
      headers: [
        { text: "Title", value: "title" },
        { text: "Program Type", value: "type" },
        { text: "Active Users", value: "activeUsers" },
        { text: "Completed Users", value: "completedUsers" },
      ],
      blockReportHeaders: [
        { text: "Day", value: "day" },
        { text: "# Users Exercise Dots", value: "exerciseDots" },
        { text: "# Users Nutrition Dots", value: "nutritionDots" },
        { text: "# Users Mindset Dots", value: "mindsetDots" },
        { text: "# Users Logged the Day's Session", value: "daySessionDots" },
      ],
    };
  },
  apollo: {
    workoutBlocks: {
      query: WORKOUT_BLOCKS_NODE_QUERY,
      variables() {
        return {
          withUsers: false,
          first: 300, // :)
        };
      },
      update(data) {
        data.workoutBlocks.edges.forEach((item) => {
          let data = {
            value: item.node.id,
            text: `${item.node.title}`,
          };
          this.blockList.push(data);
        });

        return extractNodes(data.workoutBlocks.edges);
      },
    },
    blockReport: {
      query: BLOCK_REPORT,
      variables() {
        return {
          workoutBlockId: decodeId(this.selectedBlockId),
        };
      },
      result(response) {
        if (response.data) {
          this.blockReportData = response.data.blockReport;
        }
      },
      skip() {
        return !this.selectedBlockId;
      },
    },
    nutritionBlocks: {
      query: NUTRITION_BLOCKS_QUERY,
      update(data) {
        return extractNodes(data.nutritionBlocks.edges);
      },
    },
  },
};
</script>
